import axios from 'axios';
import store from '@/store';

export const routes = {
  login: 'auth',
  userNavigationInfo: 'user-navigation-information',
};

const generateBearerToken = () => {
  return `Bearer ${store.getters['app/authToken']}`;
};

export const newClient = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
      Authorization: generateBearerToken(),
    },
  });
};

export const canAuth = () => {
  return !!store.getters['app/authToken'];
};
